<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <!-- <el-form-item label="选择时间：" class="query-form-item">
                <el-date-picker
                    size="mini"
                    style="width: 360px"
                    v-model="date"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="change"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item> -->
            <el-form-item label="充值类型：" class="query-form-item">
                <el-select v-model="query.is_credit" placeholder="充值类型" @change="changeSelect" style="width: 120px">
                    <el-option v-for="item in radio" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            stripe border style="width: 100%">
            <el-table-column
                label="交易记录id"
                width="164"
                align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="支付方式"
                align="center"
                width="82">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.source == 'manual'">人工</el-tag>
                    <el-tag v-if="scope.row.source == 'alipay'">支付宝</el-tag>
                    <el-tag v-if="scope.row.source == 'wechat_pay'">微信支付</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="货币类型"
                align="center"
                width="100">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.is_credit == '0'">现金充值</el-tag>
                    <el-tag v-else type="success">授信修改</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="充值金额(人民币)"
                width="130"
                align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.amount }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="备注"
                align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                fixed="right"
                width="160">
                <template slot-scope="scope">
                    <el-popover
                        v-if="scope.row.method == '3'"
                        placement="right" title
                        trigger="click">
                        <div style="width:300px;">
                            <span>{{scope.row.message}}</span>
                        </div>
                        <el-button v-if="scope.row.amount != '0.00'" slot="reference" style="margin: 0 0 10px 10px" type="info" size="mini">查看退款原因</el-button>
                    </el-popover>
                    <el-popover
                    v-else
                        placement="right" title
                        trigger="click">
                        <div style="width:300px;">
                            <img
                                style="width:100%;"
                                :src="img"
                                alt
                            />
                        </div>
                        <el-button v-if="scope.row.amount != '0.00'" slot="reference" style="margin: 0 0 10px 10px" type="primary" size="mini" :disabled="!scope.row.evidence_id" @click.native="viewVoucher(scope.row)">查看充值凭证</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total">
        </el-pagination>
    </div>
</template>

<script>
import * as api from "@/api/user/payorders";
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            radio: [
                {
                    id: "",
                    name: "全部"
                },
                {
                    id: "0",
                    name: "人工"
                },
                {
                    id: "1",
                    name: "信用额修改"
                }
            ],
            date: "",
            list: [],
            disabled: false,
            query: {
                page: 1,
                limit: 20
            },
            img: "",
            loading: false,
            filter: {}
        };
    },
    methods: {
        getList() {
            let obj = this.query;
            obj.filter = this.filter;
            api.admin_record(obj).then(res => {
                if (res.code === 0) {
                    this.list = res.data.list;
                    this.query.page = res.data.page;
                    this.query.total = res.data.total;
                    this.query.total_page = res.data.total_page;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        //查看凭证
        viewVoucher(data) {
            this.img = "";
            api.evidence_image({ id: data.evidence_id })
                .then(res => {
                    if (res.code === 0) {
                        // 提交成功, 跳转页面
                        this.img = res.data.img;
                        this.disabled = false;
                    } else {
                        this.disabled = false;
                        this.$message({
                            type: "error",
                            message: "提交失败  " + res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        //充值时间筛选
        change(tab) {
            if (tab) {
                this.query.filter.start_time = tab[0];
                this.query.filter.end_time = tab[1];
                this.getList();
            } else {
                this.query.filter.start_time = "";
                this.query.filter.end_time = "";
                this.getList();
            }
        },
        //充值类型筛选
        changeSelect(tab) {
            this.query.filter.method = tab;
            this.getList();
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        }
    },
    created() {
        if (this.$route.query.admin_id) {
            this.query.admin_id = this.$route.query.admin_id;
        }
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
